import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import { ContratacaoRotaInteligenteService } from 'src/app/services/contratacao-rota-inteligente.service';
import { LoadingGenericoComponent } from '../../../components/loading-generico/loading-generico.component';
import { AlertConfirmacaoContratacaoRotaComponent } from '../../../components/alert-confirmacao-contratacao-rota/alert-confirmacao-contratacao-rota.component';
import { HeaderComponent } from '../../../components/header/header.component';
import { BotaoChatComponent } from '../../../components/botao-chat/botao-chat.component';
import { BreadcrumbComponent } from '../../../components/breadcrumb/breadcrumb.component';
import { FormsModule } from '@angular/forms';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { RouterLink } from '@angular/router';
import { NgClass, AsyncPipe } from '@angular/common';
import { FooterComponent } from '../../../components/footer/footer.component';
import { UsuarioPermissaoPipe } from '../../../pipes/usuario-permissao.pipe';

@Component({
    selector: 'app-contratacao-plano-avulso',
    templateUrl: './contratacao-plano-avulso.component.html',
    styleUrls: ['./contratacao-plano-avulso.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent, AlertConfirmacaoContratacaoRotaComponent, HeaderComponent, BotaoChatComponent, BreadcrumbComponent, FormsModule, PopoverDirective, RouterLink, NgClass, FooterComponent, AsyncPipe, UsuarioPermissaoPipe]
})
export class ContratacaoPlanoAvulsoComponent implements OnInit {

  public loadingGenerico: boolean = false;
  public showalertConfirmacaoContratacaoRota: boolean = false; 

  public checkBox : boolean = false;

  public consultaSelecionada : any;
  public consultaEnviada : any;

  public empresa : any = localStorage.idEmpresaLogada;
  public resources : any;

  public checkPlanoStatus : boolean = false;

  public consultaAvulsa : boolean = false;

  public isMatriz : boolean = false;
  public checkPlanoFiliais : boolean = false;

  constructor( 
    private readonly Toastr : ToastrService,
    private readonly contratacaoRotaInteligenteService : ContratacaoRotaInteligenteService
  ) { }

  ngOnInit(): void {
    this.getPlanoAvulso();
  }

  public getPlanoAvulso() {

    this.loadingGenerico = true;
    this.contratacaoRotaInteligenteService.getPlanoAvulso(this.empresa)
    .pipe(take(1))
    .subscribe({
      next: (success: any) => {
          this.loadingGenerico = false;
          this.resources = success.response;
          this.isMatriz = success.response.isMatriz
      },
      error: (error) => {
        this.loadingGenerico = false;
        this.Toastr.error('Erro ao buscar planos disponiveis');
      }
    });
  }
  
  public planoFiliais(){
    this.checkPlanoFiliais = !this.checkPlanoFiliais;
  }

  public checkPlano(evento: any){
    this.checkPlanoStatus = evento;
  }

  public eventoAlertConfirmacaoContratacaoRota(evento: any) {
    this.showalertConfirmacaoContratacaoRota = evento;
  }

  public AlertConfirmacaoContratacaoRota() {
    if (this.checkBox === true) {
      this.consultaEnviada = this.consultaSelecionada
      this.showalertConfirmacaoContratacaoRota = true;
      this.consultaAvulsa = true;
    }

    else{
      this.Toastr.error('Selecione um Plano')
    }
  }

  public eventoConfirmacaoContratacaoRotaFechou(event: any) {
    this.showalertConfirmacaoContratacaoRota = event;
  }

  cardClick(empresa) {
    this.checkBox = true;
    this.consultaSelecionada = empresa
  }
}
